const product_cards = document.querySelectorAll(".collection .product-grid .grid__item");

product_cards.forEach((card) => {
  const slider_mediaElement = card.querySelector('.cust_media_slide');

  if (!slider_mediaElement) return; // Skip if no slider in this card

//   const slider_media = new Splide(slider_mediaElement, {
//     type: 'loop',
//     drag: 'free',
//     focus: 'center',
//     arrows: false,
//     pagination: true,
//     perPage: 1,
//     autoWidth: true,
//     autoScroll: {
//       speed: 1.2,
//       pauseOnHover: false,
//       pauseOnFocus: false,
//     },
//   });
//   slider_media.mount(window.splide.Extensions); // Mount with extensions

    const slider = new Splide(slider_mediaElement, {
    type: 'fade',             // 👈 Fading instead of sliding
    rewind: true,             // Go back to first slide at the end
    perPage: 1,               // One slide at a time
    arrows: false,            // Hide arrows (optional)
    pagination: true,         // Dots/pagination
    speed: 1200,               // Fade duration (ms)
    autoplay: true,           // Enable auto-rotation
    interval: 3000,           // Time between slides (ms)
    pauseOnHover: false,      // Don't pause on hover
    pauseOnFocus: false,      // Don't pause on focus
  });
  slider.mount();
});
